/* src/app/core/modules/shared/components/amount-counter/amount-counter.component.scss */
/*# sourceMappingURL=/avvera/dev/amount-counter.component.css.map */
